module.exports = __webpack_public_path__ + "files/eee8b8113c7b815267a97ce4fef873e1.svg";